const comments = [
  {
    name: '漫画迷小K',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20of%20a%20young%20girl%20with%20pink%20hair%2C%20happy%20expression%2C%20simple%20clean%20background%2C%20chibi%20style%2C%20soft%20colors&width=120&height=120&seq=avatar-01&orientation=squarish',
    text: '皮皮漫画真的太好用了！韩漫更新速度超快，画质清晰，翻页流畅。以前在别的平台追更总是慢半拍，现在每天下班第一件事就是打开皮皮漫画看最新一话。「社长大人是禽兽」追了两年，每周五更新雷打不动，爱了爱了！',
    comic: '追更中：社长大人是禽兽',
    time: '2天前',
  },
  {
    name: '热血漫爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=An%20anime%20style%20avatar%20of%20a%20young%20boy%20with%20spiky%20dark%20hair%2C%20determined%20expression%2C%20simple%20background%2C%20chibi%20style%2C%20warm%20colors&width=120&height=120&seq=avatar-02&orientation=squarish',
    text: '日漫专区分类很全，咒术回战、间谍过家家这些热门的更新很快，一些冷门老番也能找到。界面简洁没有乱七八糟的广告，阅读体验比其他平台好太多了。唯一希望的是能增加弹幕功能，看热血漫有弹幕才带劲！',
    comic: '追更中：咒术回战',
    time: '5天前',
  },
  {
    name: '国漫支持者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime%20style%20avatar%20of%20a%20young%20man%20with%20long%20black%20hair%2C%20calm%20expression%2C%20traditional%20Chinese%20style%2C%20simple%20background%2C%20chibi%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    text: '国漫这几年真的越来越好了！皮皮漫画上的一人之下、完美世界画风和剧情都是顶级水准。平台的国漫专区整理得很用心，按类型筛选很方便。从日漫入坑到现在国漫也成了我的心头好，皮皮漫画功不可没！',
    comic: '追更中：一人之下',
    time: '1周前',
  },
  {
    name: '深夜追更党',
    avatar: 'https://readdy.ai/api/search-image?query=A%20sleepy%20anime%20style%20avatar%20of%20a%20girl%20with%20glasses%20and%20messy%20hair%2C%20holding%20a%20phone%2C%20cozy%20vibe%2C%20simple%20background%2C%20chibi%20style%2C%20warm%20colors&width=120&height=120&seq=avatar-04&orientation=squarish',
    text: '免费阅读真的太良心了！之前用了好几个APP都是看几话就收费，皮皮漫画一直免费真的很感动。夜间模式对熬夜追更党太友好了，自动翻页功能躺床上看简直不要太爽。已经安利给身边所有漫友了！',
    comic: '追更中：我独自升级',
    time: '2周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1100px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">读者评价</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            来自皮皮漫画真实读者的使用体验与评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-heading text-sm text-foreground-950">{comment.name}</h3>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <p className="text-xs text-foreground-500 mt-1">{comment.comic}</p>
                  <div className="flex items-center gap-0.5 mt-2">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-500 text-xs"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 mt-3 leading-relaxed">{comment.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}